const link_list = {
    routePath: 'applications',
    actionName: 'open-application',
    iconClass: 'fa-solid fa-calendar-check',
    title: 'Upcoming Funding Calls',
    search: '',
    customDashlet: 'Upcoming',
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: '',
}
export default {link_list }